import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    dropDown: {
      fontSize: "0.9rem",
      marginLeft: "5px",
      minWidth: "11vw"
    },
    errorMsg: {
      width: "150px",
      marginLeft: "5px"
    }
  })
);
